export const isUsersnapEnabled = (stage?: string, apiKey?: string): boolean =>
  stage === "production" && Boolean(apiKey);
